"use client";
import React from "react";
import TopBarSignedIn from "./../components/common/TopBarSignedIn";
import SideMenu from "./../components/accountpersonal/SideMenu";
import ProfileSection from "./../components/accountpersonal/ProfileSection";
import PersonalInfoSection from "./../components/accountpersonal/PersonalInfoSection";
import AddressSection from "./../components/accountpersonal/AddressSection";
import AccountDataSection from "./../components/accountpersonal/AccountDataSection";
import NewsletterSection from "./../components/accountpersonal/NewsletterSection";
import NotificationsSection from "./../components/accountpersonal/NotificationsSection";
import ConfirmationSection from "./../components/accountpersonal/ConfirmationSection";
import Footer from "./../components/Footer";
import Divider from "./../components/common/Divider";
import Button from "./../components/common/Button";

function AccountPersonal() {
    return (
      <main className="flex overflow-hidden flex-col bg-white text-primary">
        <TopBarSignedIn />
        <section className="flex flex-wrap gap-10 items-start self-center mt-12 w-full max-w-[1272px] max-md:mt-10 max-md:max-w-full">
          <SideMenu />
          <article className="flex-1 shrink basis-12 min-w-60 max-md:max-w-full">
            <h1 className="text-3xl font-semibold leading-none text-gray-700 max-md:max-w-full">
              Personal Data
            </h1>
            <div className="flex flex-col justify-center p-6 mt-4 w-full rounded-2xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
              <div className="w-full max-md:max-w-full">
                <ProfileSection />
                <Divider />
                <PersonalInfoSection />
                <Divider />
                <AddressSection />
                <Divider />
                <AccountDataSection />
                <Divider />
                <Divider />
                <NewsletterSection />
                <Divider />
                <NotificationsSection />
                <Divider />
                <ConfirmationSection />
                <div className="flex flex-col items-end mt-6 w-full">
                  <Button primary size="large">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </article>
        </section>
        <Footer />
      </main>
    );
  }
  
  export default AccountPersonal;
